import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin, Calendar } from "lucide-react";
import { MEDIA, COMPANY, DIFFERENTIATORS } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const AboutSection = () => {
  return (
    <section data-testid="about-section" className="relative py-24 md:py-32 border-t border-stone-200">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <Reveal className="lg:col-span-5 relative">
            <div className="relative overflow-hidden">
              <img
                src={MEDIA.dubai}
                alt="Dubai HQ"
                className="w-full h-[520px] object-cover pencil hover:filter-none transition-all duration-1000"
              />
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-white/95 to-transparent">
                <div className="flex items-center gap-2 text-[#B8860B] text-xs uppercase tracking-[0.25em]">
                  <MapPin className="w-3 h-3" /> {COMPANY.hq}
                </div>
              </div>
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#FAF7F2] border border-[#D4AF37]/40 p-6 hidden md:block">
              <div className="flex items-center gap-2 text-[#B8860B] text-xs uppercase tracking-[0.25em] mb-2">
                <Calendar className="w-3 h-3" /> Founded
              </div>
              <div className="font-display text-4xl text-stone-900 font-light">{COMPANY.founded}</div>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-7 lg:pl-10">
            <div className="text-xs uppercase tracking-[0.25em] text-[#B8860B] font-semibold mb-4">
              02 — Who we are
            </div>
            <h2 className="font-display text-stone-900 text-4xl md:text-5xl lg:text-6xl font-light tracking-tighter mb-8">
              A consulting house<br />
              built around <span className="italic text-[#B8860B]">people</span>.
            </h2>
            <p className="text-stone-700 text-lg leading-relaxed mb-6 max-w-2xl">
              Founded in {COMPANY.founded} and headquartered in Dubai, ITHR Technologies was created to bridge a gap we kept seeing — between brilliant technology and the humans it was supposed to serve.
            </p>
            <p className="text-stone-600 leading-relaxed mb-10 max-w-2xl">
              We assemble senior, multidisciplinary teams across SAP, AI, Cloud, Cybersecurity and HR. We embed deeply, work transparently, and measure success by the outcomes our clients ship — not the slides we present.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
              {DIFFERENTIATORS.slice(0, 4).map((d) => (
                <div key={d.title} className="border border-stone-200 p-5 hover:border-[#D4AF37]/40 transition-colors">
                  <d.icon className="w-5 h-5 text-[#B8860B] mb-3" strokeWidth={1.25} />
                  <div className="font-display text-stone-900 text-lg mb-1.5">{d.title}</div>
                  <p className="text-stone-500 text-sm leading-relaxed">{d.body}</p>
                </div>
              ))}
            </div>

            <Link to="/about" data-testid="about-section-cta" className="inline-flex items-center gap-2 text-[#B8860B] hover:text-[#B8860B] link-underline">
              Read our full story <ArrowUpRight className="w-4 h-4" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
